import React from "react";
import { Card } from "primereact/card";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchGeneralInformation } from "../general-information/generalInformationSlice";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

const EntitiesSideBar = ({ isEntityPlusActive }) => {
  const location = useLocation();
  const { id } = useParams();
  const activeTab = location.pathname.split("/")[3] || "general-information";
  const dispatch = useDispatch();
  const handleLinkClick = () => {
    dispatch(fetchGeneralInformation(id));
  };

  return (
    <>
      <Card className="card-style h-full p-0">
        <div className="flex flex-column">
          <Link
            to={`/entity/${id}/info`}
            className={`sidebar-align ${activeTab === "info" ? "active-entity" : "menu-hover"}`}
            onClick={handleLinkClick}
          >
            <div className="flex align-items-center">
              <p className="sidebar-menu">General Information</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>

          {isEntityPlusActive && (
            <Link
              to={`/entity/${id}/entity-plus`}
              className={`sidebar-align ${activeTab === "entity-plus" ? "active-entity" : "menu-hover"}`}
            >
              <div className="flex align-items-center">
                <p className="sidebar-menu">Entity Plus</p>
              </div>
              <span className="pi pi-angle-right icon-color"></span>
            </Link>
          )}
          {isEntityPlusActive && (
            <Link
              to={`/entity/${id}/attachments`}
              className={`sidebar-align ${activeTab === "attachments" ? "active-entity" : "menu-hover"}`}
            >
              <div className="flex align-items-center">
                <p className="sidebar-menu">Attachments</p>
              </div>
              <span className="pi pi-angle-right icon-color"></span>
            </Link>
          )}

          <Link
            to={`/entity/${id}/addresses`}
            className={`sidebar-align ${activeTab === "addresses" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <p className="sidebar-menu">Addresses</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>

          <Link
            to={`/entity/${id}/key-personnel`}
            className={`sidebar-align ${activeTab === "key-personnel" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <p className="sidebar-menu">Key Personnel</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          {/* <Link
            to={`/entity/${id}/documents`}
            className={`sidebar-align ${activeTab === "documents-grid" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-file icon-color"></span>
              <p className="sidebar-menu">Documents Grid</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link> */}
        </div>
      </Card>
    </>
  );
};

EntitiesSideBar.propTypes = {
  isEntityPlusActive: PropTypes.bool,
};

export default EntitiesSideBar;
